<template>
  <div class="goods-detail__wrap">
    <fixed-header ref="header" :notShowBack="notShowBack" :shareContent="shareContent" :weixinShare="true"
                  title="商品详情"></fixed-header>
    <div class="goods-detail scroll-touch">
      <div class="goods-detail__img" @click="preiviewGoods">
        <mt-swipe :auto="0" :continuous="false" :showIndicators="false" @change="getImgIndex">
          <mt-swipe-item v-for="(item,index) in goodsDetail.goodsImagesList" :key="index">
            <img :src="item.imageUrl"/>
          </mt-swipe-item>
          <span v-if="showIndex" class="goods-detail__img-index">{{ showIndex }}</span>
        </mt-swipe>
      </div>
      <div v-if="!isFlashSale" class="goods-detail__intro">
        <div class="goods-detail__intro-title add_dot2">{{ goodsDetail.goods.goodsName }}</div>
        <div class="goods-detail__intro-price">
          <span>{{ goodsPrice }}</span>
          <span v-if="isMallVip" class="vip">
            <span class="vtag">VIP</span>
            <span class="tag">￥</span>{{ goodsDetail.goods.memberGoodsPrice }}
          </span>
          <i v-if="isPreSell" class="icon presell"></i>
        </div>
        <div v-if="isPreSell" class="goods-detail__intro-presell">
          <section>定金 ￥{{ preSellInfo.deposit }}</section>
          <section>
            <p>支付尾款时间: {{ preSellTime }}</p>
            <p v-if="preSellInfo.deliveryTime">{{ preSellDeliveryTime }} 开始发货</p>
          </section>
        </div>
        <div class="goods-detail__intro-sales">
          <span>{{ postage }}</span>
          <span v-if="!isPreSell">已售&nbsp;&nbsp;{{ goodsDetail.goods.salesSum }}件</span>
        </div>
      </div>
      <div v-if="isFlashSale" class="goods-detail__flashSale">
        <div class="goods-detail__flashSale-content">
          <div class="goods-detail__flashSale-icon">
            <i class="icon haowu_spike"></i>
          </div>
          <div class="goods-detail__flashSale-price">
            <div>
              <span
                  v-if="!flashSaleInfo.pointPrice"><span>¥</span>{{ String(flashSaleInfo.price).split(".")[0] }}</span>
              <span v-if="!flashSaleInfo.pointPrice">.{{ String(flashSaleInfo.price).split(".")[1] }}</span>
              <span v-if="flashSaleInfo.pointPrice" class='points_price'>{{ flashSaleInfo.pointPrice }}{{coinName}}</span>
              <span class='marketPrice'>¥{{ goodsDetail.goods.marketPrice }}</span>
            </div>
            <div>
              <span>包邮</span>
              <span>秒杀剩余 {{ flashSaleInfo.store || 0 }}件</span>
            </div>
          </div>
          <div class="goods-detail__flashSale-countdown">
            <countdown v-if="!flash_day || flash_day!='tomorrow'" :flashSaleInfo="flashSaleInfo"></countdown>
          </div>
        </div>
        <div class="goods-detail__flashSale-title add_dot2">{{ goodsDetail.goods.goodsName }}</div>
      </div>
      <pre-sell-num :isPreSell="isPreSell" :preSellInfo="preSellInfo" @share="showShareModal"></pre-sell-num>
      <div class="goods-detail__sku-wrap">
        <div v-if="!isPreSell&&isMultipleSize" class="goods-detail__sku" @click="addCart('addCart')">
          <div>选择</div>
          <div class="add_dot">请选择{{ isMultipleSize }}</div>
          <div>
            <i class="icon gray_left_arrow"></i>
          </div>
        </div>
        <div v-if="showParams" class="goods-detail__sku" @click="isShowProductParams=true;hasAnyAction=true">
          <div>产品参数</div>
          <div class="add_dot">{{ showParams }}</div>
          <div>
            <i class="icon gray_left_arrow"></i>
          </div>
        </div>
        <div v-if="!isPointsGoods" :mg-stat-lob="`goods_id=${goodsId}`" class="goods-detail__sku"
             mg-stat-click mg-stat-custom="label=text&cont=购前需知&direct=cntp"
             @click="showHelp=true;hasAnyAction=true">
          <div>购前需知</div>
          <div>常见问题汇总</div>
          <div><i class="icon gray_left_arrow"></i></div>
        </div>
        <div v-if="showGoodsRegionRestrict" class="goods-detail__sku" @click="showGoodsRegionRestrictFlag=true">
          <div>配送</div>
          <div class="add_dot goods-detail__tip">暂不支持配送区域</div>
          <div><i class="icon gray_left_arrow"></i></div>
        </div>
        <div v-if="!isPointsGoods" class="goods-detail__sku">
          <div>订单查询</div>
          <div class="add_dot goods-detail__tip">芒果TV App-个人中心-芒果好物内查询订单</div>
        </div>
        <div v-if="isPointsGoods" class="goods-detail__sku">
          <div>订单查询</div>
          <div v-if="fromJubaopen" class="add_dot goods-detail__tip">芒果TV-聚宝盆-我的背包-兑换明细</div>
          <div v-else class="add_dot goods-detail__tip">芒果TV App-我的积分-兑换记录内查询订单</div>
        </div>
      </div>
      <div v-if="showActivity" class="goods-detail__activity">
        <div>促销活动</div>
        <ul>
          <li v-for="(item,index) in goodsDetail.order_prom" :key="index">
            <span class="goods_tag">{{ item.tags }}</span> {{ item.desc }}
          </li>
        </ul>
      </div>
      <div v-if="isShowBanner" class="goods-detail__banner">
        <img :src='bannerInfo.adCode' @click="gotoLink(bannerInfo.adLink)">
      </div>
      <div v-if="allCommentList.length" class="goods-detail__comments">
        <div class="goods-detail__comments-head">
          <span>商品评价&nbsp;({{ allCommentNum }})</span>
          <span>好评率:{{ goodCommentPercent }}</span>
        </div>
        <goods-comments v-for="(item,index) in allCommentList" v-if="index<2" :key="index"
                        :data="item"></goods-comments>
        <div v-if="showCommentArrow" class="goods-detail__comments-footer" @click="gotoComments">
          <div>查看更多评论</div>
          <div>
            <i class="icon light_left_arrow"></i>
          </div>
        </div>
      </div>
      <div class="goods-detail__desc">
        <div v-html="goodsDetail.goods.goodsContent"></div>
      </div>
    </div>
    <cart-button v-if="!isPointsGoods" :goodsId="goodsId" :isMultiple="isMultipleSize" :isPreSell="isPreSell"
                 :nowGoodsNum="nowGoodsNum" :originPage="nowPageObj" :preSellInfo="preSellInfo"
                 @change="addCart"></cart-button>
    <points-button v-if="isPointsGoods" :flashSaleInfo="flashSaleInfo" :flash_day="flash_day" :goodsId="goodsId"
                   :nowGoodsNum="nowGoodsNum" :showGotoLink="showGotoLink" @change="addCart"></points-button>
    <mt-popup v-model="isShowProductParams" class="goods-detail__popup" position="bottom">
      <product-params :data="paramsInfo" @close="isShowProductParams=false"></product-params>
    </mt-popup>
    <mt-popup v-model="isShowSkuParams" class="goods-detail__popup" position="bottom">
      <sku-params :clickType="clickType" :data="goodsDetail" :flashSaleInfo="flashSaleInfo" :goodsFrom="goodsFrom"
                  :isPointsGoods="isPointsGoods" :isPreSell="isPreSell" :preSellInfo="preSellInfo" :storeId="storeId"
                  :vipType="vipType"
                  @chang_num="getSelectGoodsNum" @close="isShowSkuParams=false"></sku-params>
    </mt-popup>
    <mt-popup v-model="showHelp" class="goods-detail__popup" position="bottom">
      <problem-help :goods_id="goodsId" @close="showHelp=false"></problem-help>
    </mt-popup>
    <mt-popup v-model="showGoodsRegionRestrictFlag" position="bottom" style="max-height: 60%">
      <goods-region-restrict :list="goodsDetail.regionRestrictList"
                             @close="showGoodsRegionRestrictFlag=false"></goods-region-restrict>
    </mt-popup>
    <goods-preview :defaultIndex="defaultImgIndx" :images="allImgs" :isShow="isPreviewGoods"
                   @close="closePreview"></goods-preview>
    <qr-code v-if="isPc" :isShow="showQrCode" :url="nowUrl" @close="showQrCode=false"></qr-code>
    <wake-button v-if="!isPointsGoods"></wake-button>
    <home-nav v-if="!isPointsGoods" :origin="nowPageObj"></home-nav>
  </div>
</template>
<script>
import GoodsComments from 'components/goods/GoodsComments';
import FixedHeader from 'components/common/FixedHeader';
import ProductParams from 'components/goods/ProductParams';
import SkuParams from 'components/goods/SkuParams';
import CartButton from 'components/common/CartButton';
import ProblemHelp from 'components/common/ProblemHelp';
import GoodsPreview from 'components/common/GoodsPreview';
import HomeNav from 'components/common/HomeNav';
import QrCode from 'components/common/QrCode';
import PreSellNum from 'components/goods/PreSellNum';
import Countdown from 'components/goods/Countdown';
import PointsButton from 'components/goods/PointsButton';
import GoodsRegionRestrict from 'components/goods/GoodsRegionRectrict';
import * as goodsApis from 'apis/goods';
import * as userApis from 'apis/user';
import * as homeApis from 'apis/home';
import * as commentApis from 'apis/comments';
import { getMgtvUserTicket } from 'utils/user';
import { getQueryParams } from 'utils';
import { setWeixinShare } from 'utils/weixin';
import { dateFormater } from 'utils/date';
import { beforeRouteChange, initCloseUpload, setFixedParams, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import { FLASH_SALE, PRE_SELL_CODE } from 'constants/goods';
import DataStorage from 'utils/dataStore';
import WakeButton from 'components/common/WakeButton';
import Env from 'utils/env';
import _ from 'lodash';
import MgStat from 'MgStat';

export default {
  components: {
    FixedHeader,
    GoodsComments,
    ProductParams,
    SkuParams,
    QrCode,
    CartButton,
    GoodsPreview,
    PreSellNum,
    WakeButton,
    HomeNav,
    ProblemHelp,
    Countdown,
    PointsButton,
    GoodsRegionRestrict,
  },
  data() {
    const {
      id: goodsId, showBack, flash_day, vipType,
    } = getQueryParams();
    const [router] = window.location.href.split('?');
    return {
      isPc: Env.isPc,
      nowUrl: `${router}?id=${goodsId}&showBack=${showBack}`,
      showQrCode: false,
      nowPageObj: this,
      notShowBack: !showBack,
      goodsId: goodsId ? Number(goodsId) : 0,
      defaultImgIndx: 0,
      isShowSkuParams: false,
      isShowProductParams: false,
      showHelp: false,
      showGoodsRegionRestrictFlag: false,
      goodsDetail: {
        filterSpec: {},
        goods: { shipping_price: '' },
        goodsImagesList: [],
        specGoodsPrice: {},
        regionRestrictList: [],
      },
      allImgs: [],
      commentCount: {
        topRate: 100,
      },
      allCommentNum: 0,
      allCommentList: [],
      nowGoodsNum: 0,
      showParams: '',
      paramsInfo: [],
      clickType: 'addCart',
      isPreviewGoods: false,
      hasAnyAction: false, // 是否有操作
      hasRouteChange: false,
      shareContent: null,
      preSellInfo: {},
      flashSaleInfo: {},
      isShowBanner: false, // 是否显示广告banner
      bannerInfo: {},
      showGotoLink: false,
      flash_day,
      vipType,
    };
  },
  computed: {
    fromJubaopen() {
      return this.$route.query.from === 'jubaopen_shop_home';
    },
    showActivity() {
      const { goodsDetail: { goods: { order_prom } } } = this;
      return Array.isArray(order_prom);
    },
    showGoodsRegionRestrict() {
      const {
        goodsDetail: {
          goods: { isVirtual },
          regionRestrictList,
        },
      } = this;
      return (
        isVirtual != 1 &&
          regionRestrictList &&
          Array.isArray(regionRestrictList) &&
          regionRestrictList.length
      );
    },
    storeId() {
      const { goodsDetail: { goods: { storeId } } } = this;
      return storeId;
    },
    isPreSell() {
      return !_.isEmpty(this.preSellInfo);
    },
    isPointsGoods() {
      const { goodsDetail: { goods: { isPointsGoods } } } = this;
      return isPointsGoods;
    },
    goodsFrom() {
      const { goodsDetail: { goods: { goodsFrom } } } = this;
      return goodsFrom;
    },
    isFlashSale() {
      return !_.isEmpty(this.flashSaleInfo);
    },
    isMallVip() {
      const { goodsDetail: { goods } } = this;
      return goods.promType === 3 && goods.memberGoodsPrice;
    },
    preSellTime() {
      const {
        preSellInfo: { retainageStart, retainageEnd },
      } = this;
      return `${dateFormater(retainageStart * 1000)} ~ ${dateFormater(retainageEnd * 1000)}`;
    },
    postage() {
      const {
        goodsDetail: {
          goods: { isFreeShipping, shipping_price },
        },
      } = this;
      let str = '快递：';
      if (isFreeShipping) {
        str += '包邮';
      } else if (
        typeof shipping_price === 'string' &&
          shipping_price.indexOf('-') !== -1
      ) {
        str += '-';
      } else {
        str += `￥${shipping_price || 0}`;
      }
      return str;
    },
    showCommentArrow() {
      const { allCommentList } = this;
      return allCommentList.length >= 1;
    },
    showIndex() {
      const {
        defaultImgIndx,
        goodsDetail: { goodsImagesList },
      } = this;
      if (Array.isArray(goodsImagesList) && goodsImagesList.length) {
        if (goodsImagesList.length === 1) {
          return '';
        }
        return `${defaultImgIndx + 1}/${goodsImagesList.length}`;
      }
      return '';
    },
    goodCommentPercent() {
      const { topRate } = this.commentCount;
      return `${topRate}%`;
    },
    isMultipleSize() {
      // 是否多规格商品
      const {
        goodsDetail: { filterSpec },
      } = this;
      const arr = [];
      if (!_.isEmpty(filterSpec)) {
        Object.keys(filterSpec).forEach((key) => {
          arr.push(key);
        });
      }
      return arr.join(' ');
    },
    goodsPrice() {
      const {
        isPreSell,
        goodsDetail: {
          goods: { shopPrice, exchangeIntegral, exchangePrice },
        },
        preSellInfo: { minSalePrice: min, maxSalePrice: max },
      } = this;
      if (!isPreSell) {
        if (exchangeIntegral) {
          if (Number(exchangePrice)) {
            return `¥${exchangePrice}+${exchangeIntegral}${this.coinName}`;
          }
          return `${exchangeIntegral}${this.coinName}`;
        }
        return `¥${shopPrice || ''}`;
      }
      return (min && max && min !== max) ? `${min}~${max}` : min;
    },
    preSellDeliveryTime() {
      return dateFormater(this.preSellInfo.deliveryTime * 1000, 'yyyy-MM-dd');
    },
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
    showHelp: {
      handler(val) {
        if (val) {
          MgStat.send('cv', {
            goods_id: this.goodsId,
          }, {
            mod: 'c_hwissuepop',
          });
        }
      },
    },
    isShowSkuParams: {
      handler(val) {
        if (val) {
          MgStat.send('cv', {
            goods_id: this.goodsId,
          }, {
            mod: 'c_hwshoppingpop',
          });
        }
      },
    },
  },
  async created() {
    this.getGoodsDetailAd();
    this.fetchCommentCount();
    this.fetchComment();
    await this.fetchDetail();
    await setFixedParams(this);
    this.getUserPoints();
    uploadAccessData({ gid: this.goodsId });
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    // 如果在页面内部点击的跳转 则不执行了 如果是浏览器的返回按钮点击 则执行
    if (!this.hasRouteChange) {
      uploadCloseData({ gid: this.goodsId });
    }
    next();
  },
  methods: {
    showShareModal() {
      this.$refs.header.showShareModal();
    },
    setShare() {
      const url = window.location.href;
      const {
        goodsDetail: {
          goods: { goodsName },
          goodsImagesList: list,
        },
      } = this;
      if (Array.isArray(list) && list.length) {
        const [item] = list;
        this.shareContent = {
          title: goodsName,
          shareDesc: this.isPointsGoods ? `我在芒果tv${this.coinName}商城换到超值商品，你也来看看吧` : '我在芒果好物活捉一只不错的商品,来看看',
          shareUrl: url,
          shareIcon: item.imageUrl,
        };
        setWeixinShare(this.shareContent);
      }
    },
    preiviewGoods() {
      this.hasAnyAction = true;
      this.isPreviewGoods = true;
    },
    addCart(type) {
      if (Env.isPc) {
        this.showQrCode = true;
        return;
      }
      this.hasAnyAction = true;
      this.clickType = type;
      this.isShowSkuParams = true;
      let mod = 'c_hwshoppingpop';
      if (type === 'preSell') {
        mod = 'c_hwpaymoneypop';
      }
      MgStat.send('cv', {
        goods_id: this.goodsId,
      }, {
        mod,
      });
    },
    async fetchDetail() {
      try {
        const data = await goodsApis.getGoodsDetail({ id: this.goodsId });
        if (!_.isEmpty(data)) {
          this.goodsDetail = data;
          const {
            goods: {
              promType, promId, preSellInfo, flashSaleInfo,
            },
          } = data;
          if (Number(promType) === PRE_SELL_CODE && preSellInfo) {
            // 此时为预售 但是不一定能获取到活动信息 因为服务器延迟 所以得用预售信息去判断
            // this.fetchPreSellInfo(promId);
            this.preSellInfo = preSellInfo;
          } else if (Number(promType) === FLASH_SALE && flashSaleInfo) {
            // 此时为秒杀
            this.flashSaleInfo = flashSaleInfo;
          }
          const { goodsImagesList } = data;
          const arr = [];
          goodsImagesList.forEach((f) => {
            arr.push(f.imageUrl);
          });
          this.setShare();
          this.allImgs = arr;
          MgStat.send('pv', { goods_id: this.goodsId, promType, promId }, { cntp: 'haowu_goods_detail' });
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取商品详情失败:${message}`);
        if (typeof message === 'string' && message.indexOf('下架') !== -1) {
          this.$router.go(-1);
        }
      }
    },
    async fetchCommentCount() {
      const data = await commentApis.getGoodsCommentCount({
        goodsId: this.goodsId,
      });
      if (!_.isEmpty(data)) {
        this.commentCount = data;
        const tagList = this.commentCount.list;
        tagList.forEach((item) => {
          if (item.id === 0) {
            this.allCommentNum = item.total;
          }
        });
      }
    },
    async fetchComment() {
      const data = await commentApis.getGoodsComment({
        goodsId: this.goodsId,
        p: 1,
      });
      if (!_.isEmpty(data)) {
        this.allCommentList = data.list;
      }
    },
    gotoComments() {
      beforeRouteChange(
        { path: '/goods/comments', query: { id: this.goodsId } },
        this,
      );
    },
    getImgIndex(index) {
      this.hasAnyAction = true;
      this.defaultImgIndx = index;
    },
    closePreview() {
      this.isPreviewGoods = false;
    },
    async getGoodsDetailAd() {
      const data = await homeApis.getGoodsDetailAd({
        goodsId: this.goodsId,
      });
      if (!_.isEmpty(data)) {
        this.isShowBanner = true;
        this.bannerInfo = data;
      }
    },
    async getUserPoints() {
      if (!this.isPointsGoods) {
        return;
      }
      const userInfo = getMgtvUserTicket();
      if (!_.isEmpty(userInfo) && userInfo.ticket) {
        try {
          // const integral = await userApis.getUserIntegral();
          const { from } = this.$route.query;
          let integral;
          if (from && from === 'jubaopen_shop_home') {
            integral = await userApis.getUserJbpCoin(); // 聚宝盆金币
          } else {
            integral = await userApis.getUserIntegral(); // 积分
          }
          const { goods: { exchangeIntegral } } = this.goodsDetail;
          if (integral < exchangeIntegral) {
            this.showGotoLink = true;
          }
          if (this.flashSaleInfo && this.flashSaleInfo.pointPrice && this.flashSaleInfo.pointPrice <= integral) {
            this.showGotoLink = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    gotoLink(link) {
      if (!link) {
        return '';
      }
      window.location.href = link;
    },
    getSelectGoodsNum(val) {
      this.nowGoodsNum = val;
    },
  },
};
</script>

<style lang="scss">
@import '~assets/css/common';

/* mint-ui 样式调整 --start */
.mint-swipe-items-wrap {
  background: #fff;
  text-align: center;
}

.mint-popup-bottom {
  @extend .scroll-touch;
}

/* mint-ui 样式调整 --end */

.goods-detail {
  height: 100%;
  box-sizing: border-box;

  &__wrap {
    height: 100%;
  }

  &__img {
    height: 536px;

    img {
      height: 100%;
      max-width: 100%;
    }

    &-index {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 19px;
      padding: 4px 20px;
      color: #fff;
      font-size: 22px;
    }
  }

  &__intro {
    padding: 26px 36px 10px 36px;
    margin-bottom: 15px;
    background: #fff;

    &-title {
      font-size: 32px;
      margin-bottom: 10px;
      color: #000000;
      word-break: break-all;
    }

    &-price {
      height: 56px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;

      span:nth-of-type(1) {
        font-size: 42px;
        color: #ff5400;
        font-family: PingFangSC-Medium;
      }

      span:nth-of-type(2) {
        font-size: 30px;
        color: #9b9b9b;
        text-decoration: line-through;
        margin-left: 30px;
      }

      span.vip {
        font-size: 22px;
        text-decoration: none;
        color: rgba(40, 35, 35, 1);
        background: url("../../../assets/img/member/member_success_goods_tag.png") no-repeat rgb(253, 239, 225);
        background-size: 100% 100%;
        padding: 2px 5px;
        border-radius: 5px;
        font-size: 22px;
        height: 32px;
        line-height: 33px;

        .vtag {
          font-size: 22px;
          color: #fff;
        }

        .tag {
          font-size: 12px;
          color: rgba(40, 35, 35, 1);
          margin-left: 0px;
          text-decoration: none;
          border: none;
          margin-left: 6px;
        }
      }

      .presell {
        margin-top: 8px;
        margin-left: 10px;
      }
    }

    &-presell {
      section {
        &:nth-child(1) {
          margin-top: -10px;
          font-size: 26px;
          color: #ff8315;
          font-weight: bold;
        }

        &:nth-child(2) {
          margin: 5px 0;
          font-size: 22px;
          color: #999999;
        }
      }
    }

    &-sales {
      height: 40px;
      display: flex;
      justify-content: space-between;
      font-size: 22px;
      color: #666666;
    }
  }

  &__flashSale {
    font-family: PingFangSC-Medium;
    font-weight: Medium;
    background: #fff;
    width: 750px;
    box-sizing: border-box;

    &-title {
      padding: 20px 36px 10px 36px;
      font-size: 32px;
      margin-bottom: 10px;
      color: #000000;
      word-break: break-all;
    }

    &-content {
      height: 100px;
      background: url('~assets/img/flash_sale.png') no-repeat center;
      background-size: cover;
      display: flex;
      flex-wrap: nowrap;
    }

    &-icon {
      width: 118px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-price {
      width: 418px;

      div {
        &:nth-child(1) {
          height: 60px;
          line-height: 60px;

          span {
            &:nth-child(1) {
              span {
                font-size: 32px;
                color: rgba(255, 255, 255, 1);
                margin-right: 4px;
              }

              font-size: 46px;
              color: rgba(255, 255, 255, 1);
            }

            &:nth-child(2) {
              font-size: 28px;
              color: rgba(255, 255, 255, 1);
            }
          }

          .points_price {
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
          }

          .marketPrice {
            margin-left: 8px;
            font-size: 28px;
            text-decoration: line-through;
            color: rgba(255, 219, 195, 1);
          }
        }

        &:nth-child(2) {
          font-size: 20px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
          line-height: 30px;

          span {
            &:nth-child(1) {
              display: inline-block;
              width: 48px;
              height: 26px;
              background: url('~assets/img/icon/parcels.png') no-repeat center;
              background-size: contain;
              text-align: center;
              line-height: 26px;
            }

            &:nth-child(2) {
              display: inline-block;
              margin-left: 9px;
            }
          }
        }
      }
    }

    &-countdown {
      width: 214px;
      box-sizing: border-box;
      height: 60px;
      line-height: 20px;
      padding-left: 28px;
    }
  }

  &__vipDiscount {
    font-family: PingFang SC;
    font-weight: Medium;
    background: #fff;
    width: 750px;
    box-sizing: border-box;

    &-price {
      height: 100px;
      background: url("~assets/img/activity/vip_goodsInfo.png") no-repeat;
      background-size: cover;
      font-family: PingFang SC;
      color: rgba(25, 25, 25, 1);
      font-weight: 400;
      vertical-align: end;

      span {
        &:nth-child(1) {
          font-size: 48px;
          line-height: 100px;

          span {
            margin-left: 16px;
            font-size: 28px;
          }
        }

        &:nth-child(2) {
          font-size: 28px;
        }

        &:nth-child(3) {
          font-size: 28px;
          color: rgba(235, 11, 169, 1);
          margin-left: 13px;
        }

        &:nth-child(3)::after {
          background: url("~assets/img/activity/vip_discount.png") no-repeat;
          background-size: cover;
          height: 24px;
          width: 62px;
          margin-left: 6px;
          display: inline-block;
          content: "";
        }
      }

      div {
        &:nth-child(4) {
          box-sizing: border-box;
          padding: 0px 9px 0px 9px;
          background: url("~assets/img/activity/discount_bg.png") no-repeat;
          background-size: cover;
          width: 122px;
          height: 26px;
          margin-left: 6px;
          display: inline-block;
        }
      }
    }
  }

  &__sku-wrap,
  &__activity,
  &__comments {
    margin: 15px 0;
    background: #fff;
  }

  &__banner {
    position: relative;
    background: #fff;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__tip {
    flex: 1;
  }

  &__activity {
    ul {
      flex: 1;
      padding-top: 5px;
      font-size: 24px;
      color: #000000;

      li {
        display: flex;
        line-height: 28px;

        span {
          margin-right: 25px;
          flex-shrink: 0;
        }

        & + li {
          margin-top: 10px;
        }
      }
    }
  }

  &__sku,
  &__activity {
    padding: 15px 36px;
    display: flex;

    div {
      height: 37px;
      line-height: 37px;
    }

    div:nth-child(1) {
      font-size: 26px;
      color: #9b9b9b;
      width: 124px;
      margin-right: 44px;
    }

    div:nth-child(2) {
      font-size: 24px;
      color: #000000;
      width: 350px;
    }

    div:nth-child(3) {
      flex: 1;
      text-align: right;
      line-height: 20px;
    }
  }

  &__comments-head {
    display: flex;
    padding: 18px 30px 0 30px;

    :first-child {
      font-size: 26px;
      color: #000000;
    }

    :last-child {
      font-size: 26px;
      color: #ff4c00;
      margin-left: 30px;
    }
  }

  &__comments-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 42px;
    font-size: 30px;
    color: #ff5f00;
    padding: 14px 0 20px 0;

    div + div {
      margin-left: 40px;
      padding-top: 4px;
    }
  }

  &__desc {
    min-height: 600px; // v-html渲染有延迟 会造成ios端浏览器拖动时 把Button遮罩主 所以给个最小高度
    margin-top: 20px;
    margin-bottom: 120px;

    img {
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  &__popup {
    width: 100%;
  }
}
</style>
